"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var iframe_app_bi_logger_1 = require("@wix/iframe-app-bi-logger");
var bi_logger_groups_1 = require("bi-logger-groups");
function getIframeBiLogger(wixSdk) {
    var factory = iframe_app_bi_logger_1.iframeAppBiLoggerFactory(wixSdk);
    return bi_logger_groups_1.default(factory)();
}
exports.getIframeBiLogger = getIframeBiLogger;
//# sourceMappingURL=iframeBiLogger.js.map